import { Button, CloseButton, Dialog, HStack, Portal, Spinner, Text } from "@chakra-ui/react";

/**
 * Destructive-action confirmation. `body` should name the concrete user / company, never a bare
 * "Are you sure?". The confirm button carries `colorPalette="red"` for deactivations.
 */
const ConfirmDialog = ({
    open,
    onCancel,
    onConfirm,
    title,
    body,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    isLoading = false,
    destructive = true,
}) => (
    <Dialog.Root
        lazyMount
        open={open}
        onOpenChange={(e) => !e.open && !isLoading && onCancel()}
        placement="center"
        role="alertdialog"
    >
        <Portal>
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content bg="bg.card" borderWidth={1} borderColor="border.secondary" borderRadius={12} p={2} minW={96} maxW="lg">
                    <Dialog.Header>
                        <Dialog.Title color="white">{title}</Dialog.Title>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton color="white" size="sm" disabled={isLoading} />
                        </Dialog.CloseTrigger>
                    </Dialog.Header>
                    <Dialog.Body>
                        <Text color="text.grey" fontSize="sm" whiteSpace="pre-line">{body}</Text>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
                            {cancelLabel}
                        </Button>
                        <Button
                            variant={destructive ? undefined : "primary"}
                            colorPalette={destructive ? "red" : undefined}
                            onClick={onConfirm}
                            disabled={isLoading}
                        >
                            {isLoading ? <Spinner size="sm" color="white" /> : confirmLabel}
                        </Button>
                    </Dialog.Footer>
                </Dialog.Content>
            </Dialog.Positioner>
        </Portal>
    </Dialog.Root>
);

export default ConfirmDialog;
